/* eslint-disable import/extensions */
import React, {
  memo, useState, useEffect, useCallback,
} from 'react';
import { FormattedMessage } from 'react-intl';
import { PDF_DOWNLOAD_URL, IMG_DOWNLOAD_URL, CIVIL_INFO } from 'shared/constants';
import {
  ButtonUpload,
} from 'components';
import PdfIconOn from 'assets/icons/icon-pdf-on.png';
import {
  getPDF, getSubPfPdf,
} from 'shared/services/api';
import './styles/DocumentFiles.scss';
// import ButtonUploadMultiple from 'components/ButtonUpload/ButtonUploadMultiple';

interface Props {
  intl?: { formatMessage },
  detail?: any,
  phone?: string,
  lang?: string,
  token?: string,
  onGetFilePdfAction,
  onGetPDFSimulationAction,
  onGetImageAction,
  onUploadAssetAllocationPDF,
  onUploadCustomSubPfPDF,
  isQualifield?: boolean,
  assetAllocationAvailable ? :boolean,
  customSubPortfolioAvailable?: boolean,
  isFirstOneSigned ? :boolean,
  idAndPassport?: any,
  onUploadPassportAndCivilID: any,
  onGetUploadedCustomFilesAction?: any,
  onGetCustomfileByNameAction?: any,
  onDeleteCustomfileByNameAction?: any,
  isDisabled?: boolean,
  proofOfTransferAvailable?: boolean
}

const DocumentFiles: React.FC<Props> = memo((props) => {
  const {
    token,
    detail: {
      mftAvailable, crmAvailable, fatcaAvailable, crsAvailable, ndpfAvailable, imarkazRefCode,
      id, proofOfTransferAvailable,
      // civilIdFrontAvailable,
    }, phone, onGetPDFSimulationAction = () => {},
    lang,
    onGetFilePdfAction = () => {}, onGetImageAction = () => {}, onUploadAssetAllocationPDF = () => {},
    onUploadCustomSubPfPDF = () => {},
    onUploadPassportAndCivilID = () => {},
    isQualifield = false,
    assetAllocationAvailable,
    customSubPortfolioAvailable,
    isFirstOneSigned,
    idAndPassport,
    isDisabled,
    // onGetUploadedCustomFilesAction = () => {},
    // onGetCustomfileByNameAction = () => {},
    // onDeleteCustomfileByNameAction = () => {},
  } = props;
  // const initStatePassport = idAndPassport !== null && idAndPassport.passport !== undefined;
  // const initStateCivilIdBack = idAndPassport && idAndPassport.civilIdBack !== undefined;
  // const initStateCivilIdFront = idAndPassport && idAndPassport.civilIdFront !== undefined;
  // const initStateSelfie = idAndPassport && idAndPassport.selfie !== undefined;
  const [uploadedPassport, setUploadedPassport] = useState('');
  const [uploadedCivilIDBack, setUploadedCivilIDBack] = useState('');
  const [uploadedCivilIDFront, setUploadedCivilIDFront] = useState('');
  const [uploadedSelfie, setUploadedSelfie] = useState('');
  // const [uploadedProofOfTransfer, setUploadedProofOfTransfer] = useState('');
  // const [customFiles, setCustomFiles] = useState([]);

  const isNotEmpty = (str: string) => str !== undefined && str !== null && str !== '';
  const getFileType = useCallback((str: string) => {
    if (isNotEmpty(str)) {
      return str.includes('image') ? 'img' : 'pdf';
    }
    return null;
  }, []);

  useEffect(() => {
    if (idAndPassport) {
      // console.log(' getFileType(idAndPassport.passport) ', getFileType(idAndPassport.passport));

      setUploadedPassport(getFileType(idAndPassport.passport));
      setUploadedCivilIDBack(getFileType(idAndPassport.civilIdBack));
      setUploadedCivilIDFront(getFileType(idAndPassport.civilIdFront));
      setUploadedSelfie(getFileType(idAndPassport.selfie));
    }
  }, [idAndPassport, getFileType]);

  const onUploadPassport = (file) => {
    onUploadPassportAndCivilID(file, CIVIL_INFO.PASSPORT, () => {});
  };

  const onUploadCivilIdFront = (file) => {
    onUploadPassportAndCivilID(file, CIVIL_INFO.CIVIL_ID_FRONT, () => {});
  };

  const onUploadCivilIdBack = (file) => {
    onUploadPassportAndCivilID(file, CIVIL_INFO.CIVIL_ID_BACK, () => () => {});
  };

  const onUploadSelfie = (file) => {
    onUploadPassportAndCivilID(file, CIVIL_INFO.SELFIE, () => () => {});
  };

  // const onUploadCustomFile = async (file) => {
  //   onUploadPassportAndCivilID(file, 'file', async () => {
  //     const res = await onGetUploadedCustomFilesAction();
  //     setCustomFiles(res);
  //   });
  // };

  // useEffect(() => {
  //   onGetUploadedCustomFilesAction().then((res) => {
  //     setCustomFiles(res);
  //   });
  // }, [onGetUploadedCustomFilesAction]);

  // const handleDeleteAction = async (fileName) => {
  //   await onDeleteCustomfileByNameAction(fileName);
  //   const res = await onGetUploadedCustomFilesAction();
  //   setCustomFiles(res);
  // };

  const getViewForCivilIDButtons = () => {
    if (!idAndPassport) {
      return <div />;
    }
    return (
      <>
        <ButtonUpload
          fileType={uploadedCivilIDFront}
          accept="image/png, image/jpg, image/jpeg , application/pdf"
    // isDisabled={isFirstOneSigned}
          label="manageApplication.civilIDFront"
          labelUploaded="manageApplication.uploadCivilIDFront"
          isFileUploaded={uploadedCivilIDFront !== null}
          downLoadFileFunct={() => onGetImageAction(IMG_DOWNLOAD_URL.CIVIL_ID_FRONT.url,
            IMG_DOWNLOAD_URL.CIVIL_ID_FRONT.name, phone)}
          onButtonClick={(file) => { onUploadCivilIdFront(file); }}
          isDisabled={isDisabled}
        />

        {/* {idAndPassport && idAndPassport.civilIdBack && ( */}
        <ButtonUpload
          fileType={uploadedCivilIDBack}
          accept="image/png, image/jpg , image/jpeg , application/pdf"
    // isDisabled={isFirstOneSigned}
          label="manageApplication.civilIDBack"
          labelUploaded="manageApplication.uploadCivilIDBack"
          isFileUploaded={uploadedCivilIDBack !== null}
          downLoadFileFunct={() => onGetImageAction(IMG_DOWNLOAD_URL.CIVIL_ID_BACK.url,
            IMG_DOWNLOAD_URL.CIVIL_ID_BACK.name, phone)}
          onButtonClick={(file) => { onUploadCivilIdBack(file); }}
          isDisabled={isDisabled}
        />

        {/* {idAndPassport && idAndPassport.selfie && ( */}
        <ButtonUpload
          accept="image/png, image/jpg , image/jpeg , application/pdf"
          fileType={uploadedSelfie}
          // isDisabled={isFirstOneSigned}
          label="manageApplication.selfie"
          labelUploaded="manageApplication.uploadSelfie"
          isFileUploaded={uploadedSelfie !== null}
          downLoadFileFunct={() => onGetImageAction(IMG_DOWNLOAD_URL.SELFIE.url,
            IMG_DOWNLOAD_URL.SELFIE.name, phone)}
          onButtonClick={(file) => { onUploadSelfie(file); }}
          isDisabled={isDisabled}
        />
        {/* )} */}
        {/* {idAndPassport && idAndPassport.passport && ( */}
        <ButtonUpload
          fileType={uploadedPassport}
          accept="image/png, image/jpg , image/jpeg, application/pdf"
          // isDisabled={isFirstOneSigned}
          label="manageApplication.passport"
          labelUploaded="manageApplication.uploadPassport"
          isFileUploaded={uploadedPassport !== null}
          downLoadFileFunct={() => onGetImageAction(IMG_DOWNLOAD_URL.PASSPORT.url,
            IMG_DOWNLOAD_URL.PASSPORT.name, phone)}
          onButtonClick={(file) => { onUploadPassport(file); }}
          isDisabled={isDisabled}
        />

        {/* @todo for PROOF OF TRANSFER */}
        {proofOfTransferAvailable ? (
          <ButtonUpload
            fileType="img" // {uploadedProofOfTransfer}
            accept="image/png, image/jpg , image/jpeg, application/pdf"
            label="manageApplication.proof"
            labelUploaded="manageApplication.proofUpload"
            isFileUploaded={proofOfTransferAvailable}
            downLoadFileFunct={() => onGetImageAction(IMG_DOWNLOAD_URL.PROOF_OF_TRANSFER.url,
              IMG_DOWNLOAD_URL.PROOF_OF_TRANSFER.name, phone)}
          // onButtonClick={(file) => { onUploadPassport(file); }}
            isDisabled={isDisabled}
            isUploadHidden={proofOfTransferAvailable}
          />
        ) : null}

      </>
    );
  };
  return (
    <div className="documentFiles">
      <div className="documentFiles__box">
        {/*  CRM  */}
        {crmAvailable ? (
          <button
            className="documentFiles__box__item isValue"
            type="button"
            disabled={isDisabled}
            onClick={() => onGetFilePdfAction(PDF_DOWNLOAD_URL.CRM.url,
              PDF_DOWNLOAD_URL.CRM.name, phone, lang)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz pdf icon" />
            <small>{PDF_DOWNLOAD_URL.CRM.name}</small>
          </button>
        ) : (
          <p className="documentFiles__box__item notValue">
            <FormattedMessage id="dashboard.updateApp.crmFileIsNotAvailable" />
          </p>
        )}

        {/*  FATCA  */}
        { fatcaAvailable ? (
          <button
            type="button"
            className="documentFiles__box__item isValue"
            disabled={isDisabled}
            onClick={() => onGetFilePdfAction(PDF_DOWNLOAD_URL.FATCA.url,
              PDF_DOWNLOAD_URL.FATCA.name, phone, lang)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz pdf icon" />
            <small>{PDF_DOWNLOAD_URL.FATCA.name}</small>
          </button>
        )
          : (
            <p className="documentFiles__box__item notValue">
              <FormattedMessage id="dashboard.updateApp.fatcaFileIsNotAvailable" />
            </p>
          ) }

        {/*  CRS  */}
        { crsAvailable ? (
          <button
            type="button"
            className="documentFiles__box__item isValue"
            disabled={isDisabled}
            onClick={() => onGetFilePdfAction(PDF_DOWNLOAD_URL.CRS.url,
              PDF_DOWNLOAD_URL.CRS.name, phone, lang)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz pdf icon" width="24px" />
            <small>{PDF_DOWNLOAD_URL.CRS.name}</small>
          </button>
        )
          : (
            <p className="documentFiles__box__item notValue">
              <FormattedMessage id="dashboard.updateApp.crsFileIsNotAvailable" />
            </p>
          )}

        {/*  MFT Subscription  */}
        { mftAvailable ? (
          <button
            type="button"
            className="documentFiles__box__item isValue"
            disabled={isDisabled}
            onClick={() => onGetFilePdfAction(PDF_DOWNLOAD_URL.MFT.url,
              PDF_DOWNLOAD_URL.MFT.name, phone, lang)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz pdf icon" width="24px" />
            <small>{PDF_DOWNLOAD_URL.MFT.name}</small>
          </button>
        )
          : (
            <p className="documentFiles__box__item notValue">
              <FormattedMessage id="dashboard.updateApp.mftFileIsNotAvailable" />
            </p>
          )}

        <br className="linebreak1" />
        {/*  NDPF  */}
        {ndpfAvailable ? (
          <button
            type="button"
            className="documentFiles__box__item isValue"
            disabled={isDisabled}
            onClick={() => onGetFilePdfAction(PDF_DOWNLOAD_URL.NDPF.url,
              PDF_DOWNLOAD_URL.NDPF.name, phone)}
          >
            <img src={PdfIconOn} alt="Markaz pdf icon" width="24px" />
            <small data-tip data-for="ndpfTooltip">{`${PDF_DOWNLOAD_URL.NDPF.name.substr(0, 9)}...`}</small>
          </button>
        )
          : (
            <p className="documentFiles__box__item notValue">
              <FormattedMessage id="dashboard.updateApp.ndpfFileIsNotAvailable" />
            </p>
          )}

        {/*  imarkazRefCode  */}
        {imarkazRefCode ? (
          <button
            type="button"
            className="documentFiles__box__item isValue"
            disabled={isDisabled}
            onClick={() => onGetPDFSimulationAction(imarkazRefCode,
              PDF_DOWNLOAD_URL.SIMULATION.name)}
          >
            <img src={PdfIconOn} alt="Markaz pdf icon" width="24px" />
            <small data-tip data-for="simulationTooltip">{`${PDF_DOWNLOAD_URL.SIMULATION.name.substr(0, 7)}...`}</small>
          </button>
        )
          : (
            <p className="documentFiles__box__item notValue">
              <FormattedMessage id="dashboard.updateApp.simulationFileNotAvailable" />
            </p>
          )}
        {/* Button Upload */}
        {isQualifield && (
        <>
          <ButtonUpload
            isDisabled={isFirstOneSigned || isDisabled}
            label="manageApplication.assetAllocation"
            labelUploaded="manageApplication.uploadAssetAllocation"
            isFileUploaded={assetAllocationAvailable}
            downLoadFileFunct={() => getPDF(token, phone, 'aa')}
            onButtonClick={(file) => { onUploadAssetAllocationPDF(file); }}
          />

        </>
        )}

        {/* )} */}
      </div>
      <div className="documentFiles__box" />
      {/* **************** IMAGE **************** */}
      <div className="documentFiles__box">
        {/*  civilId Front  */}
        {/* {civilIdFrontAvailable ? (
          <button
            className="documentFiles__box__item isValue"
            type="button"
            onClick={() => onGetImageAction(IMG_DOWNLOAD_URL.CIVIL_ID_FRONT.url,
              IMG_DOWNLOAD_URL.CIVIL_ID_FRONT.name, phone)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz img icon" />
            <small><FormattedMessage id="manageApplication.civilIDFront" /></small>
          </button>
        ) : (
          <p className="documentFiles__box__item notValue">
            <img className="documentFiles__box__item__img" src={ImageIcon} alt="Markaz img icon" />
            <FormattedMessage id="manageApplication.civilIDFront" />
          </p>
        )} */}

        {/*  civilId Back  */}
        {/* {civilIdFrontAvailable ? (
          <button
            className="documentFiles__box__item isValue"
            type="button"
            onClick={() => onGetImageAction(IMG_DOWNLOAD_URL.CIVIL_ID_BACK.url,
              IMG_DOWNLOAD_URL.CIVIL_ID_BACK.name, phone)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz img icon" />
            <small><FormattedMessage id="manageApplication.civilIDBack" /></small>
          </button>
        ) : (
          <p className="documentFiles__box__item notValue">
            <img className="documentFiles__box__item__img" src={ImageIcon} alt="Markaz img icon" />
            <FormattedMessage id="manageApplication.civilIDBack" />
          </p>
        )} */}

        {/*   passport  */}
        {/* {civilIdFrontAvailable ? (
          <button
            className="documentFiles__box__item isValue"
            type="button"
            onClick={() => onGetImageAction(IMG_DOWNLOAD_URL.PASSPORT.url,
              IMG_DOWNLOAD_URL.PASSPORT.name, phone)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz img icon" />
            <small><FormattedMessage id="manageApplication.passport" /></small>
          </button>
        ) : (
          <p className="documentFiles__box__item notValue">
            <img className="documentFiles__box__item__img" src={ImageIcon} alt="Markaz img icon" />
            <FormattedMessage id="manageApplication.passport" />
          </p>
        )} */}

        {/*   SELFIE  */}
        {/* {civilIdFrontAvailable ? (
          <button
            className="documentFiles__box__item isValue"
            type="button"
            onClick={() => onGetImageAction(IMG_DOWNLOAD_URL.SELFIE.url,
              IMG_DOWNLOAD_URL.SELFIE.name, phone)}
          >
            <img className="documentFiles__box__item__img" src={PdfIconOn} alt="Markaz img icon" />
            <small><FormattedMessage id="manageApplication.selfie" /></small>
          </button>
        ) : (
          <p className="documentFiles__box__item notValue">
            <img className="documentFiles__box__item__img" src={ImageIcon} alt="Markaz img icon" />
            <FormattedMessage id="manageApplication.selfie" />
          </p>
        )} */}

        {getViewForCivilIDButtons()}

      </div>
      {isQualifield && (
      <div className="documentFiles__box">

        <ButtonUpload
          isDisabled={isFirstOneSigned || isDisabled}
          label="manageApplication.uploadedCustom"
          labelUploaded="manageApplication.uploadCustom"
          isFileUploaded={customSubPortfolioAvailable}
          downLoadFileFunct={() => getSubPfPdf(id, token)}
          onButtonClick={(file) => { onUploadCustomSubPfPDF(file); }}
        />

        {/* <ButtonUploadMultiple onDeleteCustomfileByNameAction={handleDeleteAction} onGetCustomfileByNameAction={onGetCustomfileByNameAction} files={customFiles} label="manageApplication.uploadCustom" onButtonClick={(file) => { onUploadCustomFile(file); }} /> */}

      </div>
      )}
    </div>
  );
});

export default DocumentFiles;
